'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fad';
var iconName = 'bug';
var width = 576;
var height = 512;
var aliases = [];
var unicode = 'f188';
var svgPathData = ['M192 96l0 3.6c0 15.7 12.7 28.4 28.4 28.4l135.1 0c15.7 0 28.4-12.7 28.4-28.4l0-3.6c0-53-43-96-96-96s-96 43-96 96zm72 184l0 230.2c7.8 1.2 15.8 1.8 24 1.8s16.2-.6 24-1.8L312 280c0-13.3-10.7-24-24-24s-24 10.7-24 24z', 'M531.2 153.6c14.1-10.6 17-30.7 6.4-44.8s-30.7-17-44.8-6.4L384 184c-12.3-5.1-25.8-8-40-8l-112 0c-14.2 0-27.7 2.8-40 8L83.2 102.4C69.1 91.8 49 94.7 38.4 108.8s-7.7 34.2 6.4 44.8l97.8 73.3c-5.3 8.9-9.3 18.7-11.8 29.1L32 256c-17.7 0-32 14.3-32 32s14.3 32 32 32l96 0 0 32c0 2.6 .1 5.3 .2 7.9L44.8 422.4c-14.1 10.6-17 30.7-6.4 44.8s30.7 17 44.8 6.4l63.1-47.3c23.2 44.2 66.5 76.2 117.7 83.9L264 280c0-13.3 10.7-24 24-24s24 10.7 24 24l0 230.2c51.2-7.7 94.5-39.7 117.7-83.9l63.1 47.3c14.1 10.6 34.2 7.7 44.8-6.4s7.7-34.2-6.4-44.8l-83.4-62.5c.1-2.6 .2-5.2 .2-7.9l0-32 96 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-98.8 0c-2.5-10.4-6.5-20.2-11.8-29.1l97.8-73.3z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faBug = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;